<ss-pagination [total]="total" [page]="page" [pageSize]="pageSize" [pageSizeOptions]="sizes" [label]="label" [disabled]="!!table.loading" (pageChange)="change($event)"></ss-pagination>
